module.exports = __webpack_public_path__ + "img/ic_qiyerenzheng.45b66ecb.svg";